import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withApi } from "@tencent/react-aio"
import * as ActionTypes from "@/stores/sale/actions"
import _ from "lodash"
import dayjs from "dayjs"

// 根据employeeId找到Employee
class EmployeeInfo extends React.Component {
  static propTypes = {
    employeeId: PropTypes.number,
    treeDate: PropTypes.string, // 取组织架构树的时间
  }

  // 默认显示今天的负责人，也可以显示指定时间段内所有的负责人
  static defaultProps = {
    treeDate: dayjs().format("YYYY-MM-DD"),
  }

  componentDidMount() {
    const { webApi, employee, treeDate } = this.props

    if (!employee) {
      webApi.getOrganizationTreeIfNeed().dispatch(ActionTypes.FETCH_ORGANIZATION_TREE_WITH_DATE_RANGE, {
        data: {
          snapshot_date: treeDate,
        },
      })
    }
  }

  render() {
    const { employee } = this.props

    let age = null
    if (employee) {
      age = dayjs().diff(dayjs(employee.hireTime), "month")
    }

    if (typeof age === "number" && !_.isNaN(age)) {
      return (
        <span className="user-info age" title={"司龄：" + age + "个月"}>
          {age}
        </span>
      )
    } else {
      return null
    }
  }
}

function mapStateToProps(state, ownProps) {
  // 所有符合teamId的负责人
  let employee = null

  // 遍历树查找负责人
  if (state.organizationTree.treeWithDateRange) {
    const findLeader = (teams) => {
      teams instanceof Array &&
        teams.forEach((team) => {
          findLeader(team.children)

          team.employees instanceof Array &&
            team.employees.forEach((e) => {
              if (e.userId === ownProps.employeeId) {
                employee = e
              }
            })
        })
    }

    findLeader(state.organizationTree.treeWithDateRange.teams)
  }

  return {
    employee: employee,
  }
}

export default withApi(connect(mapStateToProps)(EmployeeInfo))
